import { canUseDOM } from './canUseDOM';
export var isIE11 = canUseDOM && !!window.MSInputMethodContext && !!document.documentMode;
export var isAppleMobile = function isAppleMobile() {
  return typeof document !== 'undefined' && (['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || navigator.userAgent.includes('Mac') && 'ontouchend' in document);
};